import { Button, Select } from "antd";
import React from "react";
import { useTemplate } from "../../utils/Template";


export default function ColourPicker(props) {


    const [template, setTemplate] = useTemplate();
    const { allow_none = false, value = 1, colours = [], onChange = () => { }, allow_gradient = false, disabled=false } = props;

    // set to default if colour / gradient does not exist in template
    let _value = (template.colours.find(item => item.id === value) || template.gradients.find(item => item.id === value)) ? value : 0;

    const drawColor = (_id) => {

        // check if it's a colour or a gradient by id (odd = colour, even = gradient)
        let _colour;
        if (_id % 2) {
            _colour = template.colours.find(item => item.id === _id)
        } else {
            _colour = template.gradients.find(item => item.id === _id)
        }
        let _style = _colour.style;


    

        return (

            <div>
                <div style={{ "width": "25px", "height": "25px", "borderRadius": "2px", "paddingLeft": "4px", "margin": "0px" }}>
                    <div style={{ "background": _style, "paddingLeft": "3px", "height": "22px", "cursor": "pointer", "boxShadow": "inset 0 0 2px #aaa", "borderRadius": "3px", "marginTop": "3px" }}>&nbsp;</div>
                </div>
            </div>
        )
    }


    


    return (
        <>  
            <Select disabled={disabled} value={_value} onChange={(e) => onChange(e)} className="color-select" style={{ "width": "100%" }} showSearch >
                <Select.OptGroup label="Colours" >

                    {
                        (allow_none &&
                            <Select.Option value={0} style={{ "padding": "4px 4px" }}>
                                <div style={{ "display": "flex", "alignItems": "center", "justifyContent": "left" }}>
                                    <span><small>&nbsp;&nbsp; Default</small></span>
                                </div>
                            </Select.Option>
                        )
                    }

                    {template.colours.map((item, index) => {


                        return (
                            <Select.Option key={item.id} value={item.id} style={{ "padding": "4px 4px" }}>
                                <div style={{ "display": "flex", "alignItems": "center", "justifyContent": "left" }}>
                                    {drawColor(item.id)}<span style={{ fontSize: "12px" }}> &nbsp;{item.name}</span>
                                </div>
                            </Select.Option>
                        )
                    })}
                </Select.OptGroup>
                {(allow_gradient &&
                    <Select.OptGroup label="Gradients" >
                        {template.gradients.map((item, index) => {
                            return (
                                <Select.Option key={item.id} value={item.id} style={{ "padding": "4px 4px" }}>
                                    <div style={{ "display": "flex", "alignItems": "center", "justifyContent": "left" }}>
                                        {drawColor(item.id)}<span style={{ fontSize: "12px" }}> &nbsp;{item.name}</span>
                                    </div>
                                </Select.Option>
                            )
                        })}
                    </Select.OptGroup>
                )}
            </Select>
        </>
    )
}